// extracted by mini-css-extract-plugin
export default {"root":"globalError_root__xvF1S","label":"globalError_label__Rd3dc","title":"globalError_title__GZN7m","description":"globalError_description__lUWM3"};